import { Stack, styled } from '@mui/material'
import React from 'react'

import { useStore } from '@/store'
import HeaderWrapper from '@/ui/molecules/HeaderWrapper'
import SignMethod from '@/ui/molecules/SignMethod'

const StyledDiv = styled(Stack)`
  justify-content: center;
  align-items: center;
  align-self: center;
  width: 100%;
  max-width: 25rem;
  height: 100%;
  gap: 2rem;
`

const StepOne: React.FC = () => {
  const { increaseStep } = useStore()

  return (
    <StyledDiv>
      <HeaderWrapper
        title={
          <>
            Welcome to Neumi, <span style={{ fontWeight: 400 }}>powered by</span>{' '}
            <span style={{ whiteSpace: 'nowrap' }}>Limitless Minds</span>
          </>
        }
        description={
          <>
            You’re getting access to the Neumi platform.
            <br />
            <br />
            <strong>Plus:</strong> Our Newsletter, The Limitless Minds Playbook
            <br />
            Monthly mindset tools, performance hacks, podcast highlights, and insights from world-class coaches.
          </>
        }
      />
      <SignMethod
        showTerms={true}
        onGoogleClick={increaseStep}
        onMicrosoftClick={increaseStep}
        onEmailClick={increaseStep}
      />
    </StyledDiv>
  )
}

export default StepOne
